import { createStore, applyMiddleware, combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import mealAppReducer from "./Redux/reducer";
import reportReducer from "./Redux/reportSlice";
import persistApiDataSlice from "./Redux/persistApiDataSlice";
import { thunk } from "redux-thunk";

const persistConfig = {
  key: "persistApiData",
  storage,
};

const persistedReducer = persistReducer(persistConfig, persistApiDataSlice);

let reducers = combineReducers({
  persistApiData: persistedReducer, // Now includes both locations and permissions
  mealAppReducer,
  report: reportReducer,
});

const store = createStore(reducers, applyMiddleware(thunk));

export const persistor = persistStore(store);

export default store;
